import { useEffect, useState } from 'react';
import { getSiteContent } from '../../../services/api';
import AboutUsLayout from "../../AboutUsLayout";
import "./Projetos.css";

const projetosFallback = [
  {
    financiador: "FAPEAM",
    financiadorClass: "badge-fapeam",
    periodo: "2022–2024",
    titulo: "Recuperação e Reestruturação do CEDOMCA",
    edital: "Edital nº 005/2022 – HUMANITAS – CT&I FAPEAM",
    coordenacao: "Profa. Dra. Lucyanne de Melo Afonso",
    descricao: "Recuperação e reestruturação do Laboratório/Centro de Documentação e Memória da Cultura na Amazônia (CEDOMCA). Incluiu higienização e catalogação do acervo, criação de sistema de dados, oficinas, ciclos de palestras e eventos científicos.",
    objetivos: [
      "Organização, higienização e catalogação do acervo",
      "Criação de sistema de dados digital do acervo",
      "Realização de oficinas e ciclos de palestras",
      "Promoção de eventos científicos sobre memória das artes",
    ],
  },
  {
    financiador: "FAPEAM",
    financiadorClass: "badge-fapeam",
    periodo: "2022–2023",
    titulo: "Uma historiografia do ensino de música em Manaus no século XX",
    edital: "Edital nº 014/2022 – PAPD",
    coordenacao: "Profa. Dra. Lucyanne de Melo Afonso (Labem/FAARTES-UFAM)",
    descricao: "Estudo sobre o ensino da música em Manaus no século XX, com foco em interfaces culturais, socioculturais e políticas. Envolveu laboratórios de música, criação de plataformas digitais, oficinas, palestras, exposições e seminários.",
    objetivos: [
      "Mapear e historicizar o ensino de música em Manaus",
      "Criar plataformas digitais de divulgação científica",
      "Organizar exposições, oficinas e seminários",
      "Produzir cartilhas pedagógicas e publicações científicas",
    ],
  },
  {
    financiador: "PIBIC/PIBITI",
    financiadorClass: "badge-pibic",
    periodo: "2021–2024",
    titulo: "Projetos de Iniciação Científica e Tecnológica",
    edital: "CNPq / FAPEAM / UFAM",
    coordenacao: "Profa. Dra. Lucyanne de Melo Afonso (supervisora)",
    descricao: "Pesquisas sobre arquivos do antigo Departamento de Artes da UFAM, mapeamento do ensino de música em diferentes regiões do Amazonas, codificação de acervos musicais e arquivísticos, além de projetos de iniciação tecnológica como jogos musicais de tabuleiro.",
    objetivos: [
      "Mapear arquivos históricos do Departamento de Artes (1980–2017)",
      "Mapear o ensino de música nas mesorregiões do Amazonas",
      "Codificar acervos musicais fonográficos e arquivísticos",
      "Desenvolver jogos musicais de tabuleiro para o ensino da música",
    ],
  },
];

export default function Projetos() {
  const [dbProjects, setDbProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await getSiteContent();
        if (data.length > 0) {
          const item = data[0];
          if (item.projects && item.projects.length > 0) {
            setDbProjects(item.projects);
          }
        }
      } catch (err) {
        console.error('Erro ao buscar projetos:', err);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const itemsToRender = dbProjects.length > 0
    ? dbProjects.map(proj => ({
        titulo: proj.title,
        descricao: proj.description,
        link: proj.link,
        financiador: proj.funder || "Projeto de Pesquisa",
        financiadorClass: proj.funder && proj.funder.toLowerCase().includes("pibic") ? "badge-pibic" : "badge-fapeam",
        periodo: proj.period,
        coordenacao: proj.coordinator,
        objetivos: proj.objectives || [],
      }))
    : projetosFallback;

  if (loading) {
    return (
      <AboutUsLayout activePage="projetos">
        <main className="home-main" />
      </AboutUsLayout>
    );
  }

  return (
    <AboutUsLayout activePage="projetos">
      <main className="home-main">
        {/* Hero Card */}
        <section className="home-intro-card">
          <h1 className="home-intro-title">Projetos de Pesquisa</h1>
          <p className="home-intro-text">
            O CEDOMCA desenvolve projetos de pesquisa voltados para a preservação,
            documentação e difusão do patrimônio cultural e artistic da Amazônia.
            Nossas iniciativas integram pesquisadores, alunos e comunidades em torno
            da memória amazônica.
          </p>
          <p className="home-intro-text">
            Os projetos são financiados por agências de fomento como PIBIC e FAPEAM,
            em parceria com a Universidade Federal do Amazonas (UFAM), promovendo
            pesquisa acadêmica de impacto regional e nacional.
          </p>
        </section>

        {/* Todos os Projetos */}
        <section>
          <h2 className="home-grid-title">Todos os Projetos</h2>
          <div className="projetos-list">
            {itemsToRender.map((projeto, i) => (
              <article className="projetos-card" key={i}>
                <div className="projetos-card-header">
                  <span className={`projetos-badge ${projeto.financiadorClass}`}>
                    {projeto.financiador}
                  </span>
                  {projeto.periodo && <span className="projetos-periodo">{projeto.periodo}</span>}
                </div>
                <h3 className="projetos-card-title">{projeto.titulo}</h3>
                {projeto.coordenacao && <p className="projetos-coordenacao">{projeto.coordenacao}</p>}
                <p className="projetos-card-desc">{projeto.descricao}</p>
                {projeto.link && (
                  <p className="projetos-coordenacao" style={{ marginTop: '12px' }}>
                    <strong>Link do Projeto:</strong>{' '}
                    <a
                      href={projeto.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#1565c0', textDecoration: 'underline' }}
                    >
                      Acessar link do projeto
                    </a>
                  </p>
                )}
                {projeto.objetivos && projeto.objetivos.length > 0 && (
                  <div className="projetos-objetivos">
                    <span className="projetos-objetivos-label">OBJETIVOS</span>
                    <ul className="projetos-objetivos-list">
                      {projeto.objetivos.map((obj, j) => (
                        <li key={j}>{obj}</li>
                      ))}
                    </ul>
                  </div>
                )}
              </article>
            ))}
          </div>
        </section>
      </main>
    </AboutUsLayout>
  );
}
